import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaTruck, FaIdCard, FaLeaf, FaHeart } from 'react-icons/fa';
import { motion } from 'framer-motion'; // Add framer-motion

const AboutCardSection = () => {
  const services = [
    {
      icon: <FaTruck size={30} color="#ffff" />,
      title: 'Qualité',
      subtitle: 'des produits naturels, sûrs et certifiés, élaborés à partir des meilleurs ingrédients.',
    },
    {
      icon: <FaIdCard size={30} color="#ffff" />,
      title: 'Transparence',
      subtitle: 'la confiance se construit sur la clarté et l’honnêteté dans tout ce que nous proposons.',
    },
    {
      icon: <FaLeaf size={30} color="#ffff" />,
      title: 'Durabilité',
      subtitle: 'un profond respect de la nature et des pratiques écoresponsables à chaque étape de production.',
    },
    {
      icon: <FaHeart size={30} color="#ffff" />,
      title: 'Empowerment',
      subtitle: 'placer la santé et la beauté des femmes et des hommes au cœur de notre mission, pour les accompagner vers une vie plus saine et équilibrée.',
    },
  ];

  // Animation variants for cards
  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.15,
        duration: 0.6,
        type: "spring",
      },
    }),
  };

  return (
    <div style={{ background: "#FFFFFF", padding: "30px 0" }}>
      <Container>
        <h2
          style={{
            color: "#336734",
            fontWeight: "bold",
            fontSize: "2.2rem",
            textAlign: "center",
            marginBottom: "2.5rem",
            letterSpacing: "1px"
          }}
        >
          Nos valeurs
        </h2>
        <Row className="px-4 justify-content-center">
          {services.map((service, index) => (
            <Col md={6} lg={3} className="mb-4 d-flex" key={index}>
              <motion.div
                custom={index}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={cardVariants}
                style={{ width: "100%" }}
              >
                <Card
                  className="text-center shadow-sm rounded-4 mx-2 h-100"
                  style={{
                    backgroundColor: '#FFFFFF',
                    minHeight: '220px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    border: 'none',
                    boxShadow: '0 4px 16px 0 rgba(51, 103, 52, 0.08)'
                  }}
                >
                  <Card.Body className="d-flex flex-column align-items-center justify-content-center">
                    <div className="mb-3" style={{
                      background: "#336734",
                      borderRadius: "50%",
                      width: "56px",
                      height: "56px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      {service.icon}
                    </div>
                    <Card.Title className="fw-bold mb-2" style={{ color: '#336734', fontSize: '1.15rem' }}>
                      {service.title}
                    </Card.Title>
                    <Card.Text style={{ color: '#336734', fontSize: '0.98rem', lineHeight: 1.5 }}>
                      {service.subtitle}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default AboutCardSection;
